import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomersService} from '../../../services/customers.service';
import {debounceTime, filter, switchMap, tap, distinctUntilChanged} from 'rxjs/operators';
import {ComponentAsElement} from '../../../services/common/bootstrap/annotation/component-as-element';
import {UtilsEngi} from '../../tools/UtilsEngi';
import {ReassignmentType} from "../../../model/enums/reassignmentType.enum";
import {Customer} from "../../../model/CustomerModel";

@ComponentAsElement('v-asm-order-reassignment-element')
@Component({
  selector: 'v-asm-order-reassignment',
  templateUrl: './asm-order-reassignment.component.html',
  styleUrls: []
})
export class AsmOrderReassignmentComponent implements OnInit {
  static readonly minimumCharacters = 3;

  customersObs: Observable<Customer[]>;
  showSearchResult = false;

  @Input() order: string;
  @Input() technicalId: string;
  @Input() backLink: string;
  @Input('urlApi') urlAPI : string;
  @Input() excludedCustomerUid: string;
  @Output() customerSelected = new EventEmitter();
  selectedCustomerLabel = '';
  private inputStreamObs = new EventEmitter<string>();
  searching = false;
  accountType = 'client';
  form: HTMLFormElement;
  newCustomerId: HTMLInputElement;
  reassigmentType = ReassignmentType;

  constructor(
    private customerService: CustomersService
  ) {
    this.form = <HTMLFormElement>document.getElementById('orderReassignmentForm');
    this.newCustomerId = <HTMLInputElement>this.form.elements[1];
  }

  ngOnInit() {
    this.customersObs = this.inputStreamObs.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(value => this.findByNameOrEmailOnServer(value)),
      tap(() => {
        this.showSearchResult = true;
        this.searching = false;
      })
    );
  }

  changeType(type: string) {
    type === ReassignmentType.technical ? this.newCustomerId.value = this.technicalId : this.newCustomerId.value = '';
    this.showSearchResult = false;
  }

  public inputUpdateDetected($event): void {
    this.newCustomerId.value = '';
    this.showSearchResult = false;
    if (!UtilsEngi.hasMinimumCharacters($event, AsmOrderReassignmentComponent.minimumCharacters)) {
      this.showSearchResult = false;
    } else {
      this.inputStreamObs.emit($event);
    }
  }

  public selectCustomerDetected(_customer: Customer): void {
    this.newCustomerId.value = _customer.uid;
  }

  public findByNameOrEmailOnServer(value: string): Observable<Customer[]> {
    this.searching = true;
    this.newCustomerId.value = '';
    return this.customerService.findCustomerForReassigment(value, this.excludedCustomerUid, this.urlAPI);
  }
}
